export default __webpack_public_path__ + "static/media/382.8eb4a1f6.png";